/* eslint-disable no-underscore-dangle */
import PropTypes from 'prop-types';
import React from 'react';

import { ControlPropType } from '../../ctrl_proptype';
import {
  MainfieldWrapper,
  AddImageWrapper,
  ImageContainer,
  SubtextWrapper,
  InputWrapper,
  FieldWrapper,
  Field
} from '../../common-field-styles';

const defaultImage = 'https://storage.googleapis.com/fplsblog/add_image.svg';

const AddImage = ({ ctrl }) => {
  return (
    <MainfieldWrapper>
      <FieldWrapper>
        <Field>
          <InputWrapper>
            <AddImageWrapper className={ctrl.props.placement}>
              <ImageContainer>
                <img
                  src={ctrl.props.upload_image ? ctrl.props.upload_image : defaultImage}
                  alt="media_image"
                />
              </ImageContainer>
            </AddImageWrapper>
          </InputWrapper>

          <SubtextWrapper id="descriptive text">{ctrl.props.subtext}</SubtextWrapper>
        </Field>
      </FieldWrapper>
    </MainfieldWrapper>
  );
};

AddImage.propTypes = {
  ctrl: PropTypes.shape(ControlPropType).isRequired,
};

export default AddImage;
